// extracted by mini-css-extract-plugin
export default {"articleListingHorizontalCard":"HorizontalArticleCards_articleListingHorizontalCard__GnB+-"};